module.exports = __webpack_public_path__ + "img/kf.bf2dcbae.png";